import { alpha, SxProps, Theme } from '@mui/material';

type TStyles = {
  modal: SxProps<Theme>;
  backdrop: SxProps<Theme>;
  paper: SxProps<Theme>;
  content: SxProps<Theme>;
  icon: SxProps<Theme>;
  text: SxProps<Theme>;
  actions: SxProps<Theme>;
};

export const styles: TStyles = {
  modal: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
  }),
  backdrop: {
    backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)',
  },
  paper: (theme: Theme) => ({
    width: '100%',
    maxWidth: '400px',
    margin: theme.spacing(3),
    padding: theme.spacing(4),
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.grey.additionalGrey}`,
    borderRadius: theme.spacing(2.25),
    boxShadow: `0 12px 24px 0 ${alpha(theme.palette.grey.additionalGrey || theme.palette.grey[400], 0.28)}`,
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '90vh',
    overflowY: 'auto',
    outline: 'none',
  }),
  content: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
  }),
  icon: (theme: Theme) => ({
    color: theme.palette.success.main,
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      width: '100%',
      height: '100%',
      display: 'block',
    },
  }),
  text: (theme: Theme) => ({
    color: theme.palette.text.primary,
    textAlign: 'center',
    fontWeight: 500,
  }),
  actions: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  }),
};
